mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
  updateUser(id: $id, input: $input) {
    id
    email
    phone
    firstName
    lastName
    middleName
    displayName
    avatar {
      id
      url(format: SMALL)
    }
    isAdmin
    country
    timeZone
    language
    agreeToMarketingNewsletters
    isPartner
    platformId
    currentOrganizationId
    updatedAt
  }
}
